import { render, staticRenderFns } from "./AddResourceFileModal.vue?vue&type=template&id=25b160e2&"
import script from "./AddResourceFileModal.vue?vue&type=script&lang=js&"
export * from "./AddResourceFileModal.vue?vue&type=script&lang=js&"
import style0 from "./AddResourceFileModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports